export default "__VITE_ASSET__CDCcO0z3__"